import api from '../../helpers/axios'

export const state = {
    salesReport: [],
    paymentReport: [],
    delayedInstallmentReport:[]
};

export const getters = {
    salesReport: (state) => state.salesReport,
    paymentReport: (state) => state.paymentReport,
    delayedInstallmentReport : state => state.delayedInstallmentReport
};

export const mutations = {
    setSalesReports(state, newValue) {
        state.salesReport = newValue;
    },
    setPaymentReports(state, newValue) {
        state.paymentReport = newValue;
    },
    setDelayedInstallmentReports(state, newValue) {
        state.delayedInstallmentReport = newValue;
    },
};

export const actions = {
    fetchSalesReport({ commit }, params) {
        return new Promise((resolve) => {
            api.get("/report/sales-report", {params: {...params}}).then((res) => {
                commit("setSalesReports", res.data.data);
                resolve(res.data.data)
            })
        });
    },
    fetchPaymentReport({ commit }, params) {
        return new Promise((resolve) => {
            api.get("/report/payment-report", {params: {...params}}).then((res) => {
                commit("setPaymentReports", res.data.data);
                resolve(res.data.data)
            })
        });
    },
    fetchFullReport() {
        return new Promise((resolve) => {
            api.get("/report/full-report", {}).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    fetchDelayedInstallmentReport({ commit }, params) {
        return new Promise((resolve) => {
            api.get("/report/delayed-installment-report", {params: {...params}}).then((res) => {
                commit("setDelayedInstallmentReports", res.data.data);
                resolve(res.data.data)
            })
        });
    }
};
